import { z } from "zod";

export type ImageMedia = {
  url: string; // Full resolution of the image.
  previewUrl: string; // An optimized version of the image for faster loading.
  width: number; // Pre-calculated from the backend so the fr ontend doesn't need to do it.
  height: number; // Pre-calculated from the backend so the frontend doesn't need to do it.
};

export const ImageMediaSchema = z.object({
  url: z.string().url({ message: "Invalid image URL format" }),
  previewUrl: z.string().url({ message: "Invalid image URL format" }),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
});
